export const headers = [
  { name: 'Título', field: 'title', sortable: true },
  { name: 'Número de Parcelas', field: 'number_installments', sortable: false },
  { name: 'Índice', field: 'index', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
